/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import * as Title from '../Title';
import * as Text from '../Text';
import * as Link from '../Link';

interface RichTextProps {
  m: string;
}

export const fragment = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => children,
  },
};

export const span = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => <span>{children}</span>,
  },
};

export const H1 = ({ m }: RichTextProps) => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => (
      <Title.H1 m={m}>{children}</Title.H1>
    ),
  },
});

export const H2 = ({ m }: RichTextProps) => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => (
      <Title.H2 m={m}>{children}</Title.H2>
    ),
  },
});

export const H3 = ({ m }: RichTextProps) => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => (
      <Title.H3 m={m}>{children}</Title.H3>
    ),
  },
});

export const H4 = ({ m }: RichTextProps) => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => (
      <Title.H4 m={m}>{children}</Title.H4>
    ),
  },
});

export const Default = ({ m }: RichTextProps) => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => (
      <Text.Default m={m}>{children}</Text.Default>
    ),
    [INLINES.HYPERLINK]: (_: any, children: any) => <Link.Blue>{children}</Link.Blue>,
  },
});

export const Card = ({ m }: RichTextProps) => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => (
      <Text.Card m={m}>{children}</Text.Card>
    ),
    [INLINES.HYPERLINK]: (_: any, children: any) => <Link.Blue>{children}</Link.Blue>,
  },
});

export const Legal = ({ m }: RichTextProps) => ({
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_: any, children: any) => (
      <Text.Legal m={m}>{children}</Text.Legal>
    ),
    [INLINES.HYPERLINK]: (_: any, children: any) => (
      <Link.Primary>{children}</Link.Primary>
    ),
  },
});
